module.exports = __webpack_public_path__ + "static/media/Гильманов А., Попов В., Шевелев А..c1ddc6fe.pdf";